<template>
  <portal to="anm22-portal-modal">
    <div class="modal-backdrop" :style="{ zIndex: modalZindex }">
      <div class="modal-outside-area" :style="{ zIndex: (modalZindex + 1) }" @click="closeModalClick"></div>
      <!-- Closing -->
      <div 
          v-if="closing"
          class="modal-close"
          :style="{ zIndex: modalZindex + 4}">
        <div 
            :class="['modal-body', 'com-anm22-app-scrolling-panel', 'no-header', !scroll.x ? 'no-scroll-x' : '', !scroll.y ? 'no-scroll-y' : '']" 
            :style="{ maxHeight: (modalHeight - 50) + 'px' }">
          <div class="wg-row" style="justify-content:center;">
            <div
              class="com-anm22-app-text-xl"
            >{{ confirmOnCloseMsg }}</div>
            <div class="vertical-height-div" style="height:20px;"></div>
            <div class="wg-row" style="align-items:center;justify-content:center;">
              <input
                type="button"
                class="small com-anm22-button-blue"
                :value="$anm22.strLang(lang, 'Yes', 'Sì')"
                @click="close"
              />
              <div class="com-anm22-app-horizontal-space" style="width:20px;"></div>
              <input
                type="button"
                class="small com-anm22-button-red"
                :value="'No'"
                @click="closing = false"
              />
            </div>
          </div>
        </div>
      </div>
      <div 
          class="modal"
          :style="modalDivStyle">
        <div v-if="!simple" :class="['wg-row', 'modal-header', !!$slots['header'] ? 'with-header' : '']" style="position:relative;">
          <div style="overflow:hidden;">
            <slot name="header"></slot>
          </div>
          <img 
            :src="$anm22.icons.getWorldIcon('deleteBlack')"
            :class="['com-anm22-app-img-fixed-height-m', 'btn-close', !$slots['header'] ? 'no-header' : '']"
            :style="!$slots['header'] ? { zIndex: (modalZindex + 5) } : {}"
            @click="closeModalClick" 
          >
        </div>
        <div 
            :class="['modal-body', 'com-anm22-app-scrolling-panel', !$slots['header'] ? 'no-header' : '', !scroll.x ? 'no-scroll-x' : '', !scroll.y ? 'no-scroll-y' : '']"
            :style="{ maxHeight: (modalHeight - 50) + 'px' }"
            @closeModal="signalClosing">
          <slot name="body">
            I'm the default body!
          </slot>
        </div>
      </div>
    </div>
  </portal>
</template>

<script>
import { mapState } from 'vuex';
import { Portal } from 'portal-vue';

export default {
  props: {
    portal: {
      type: Boolean,
      default: false
    },
    minWidth: String,
    width: String,
    maxWidth: String,
    fullscreen: {
      type: Boolean,
      default: false
    },
    simple: {
      type: Boolean,
      default: false
    },
    confirmOnClose: {
      type: Boolean,
      default: false
    },
    confirmOnCloseMsg: {
      type: String,
      default: ""
    },
    scroll: {
      type: Object,
      default: () => ({
        x: true,
        y: true,
      })
    }
  },
  data() {
    return {
      modalCounter: 0,
      closing: false
    }
  },
  computed: {
    ...mapState({
      lang: state  => state.lang,
      windowHeight: state => state.windowHeight
    }),
    modalHeight() {
      return this.fullscreen ? this.windowHeight : Math.floor(this.windowHeight / 100 * 90);
    },
    modalZindex() {
      return (this.modalCounter * 100) + 10000;
    },
    modalDivStyle() {
      return {
        minWidth: this.minWidth || '',
        width: this.fullscreen ? '100%' : (this.width || ''),
        maxWidth: this.maxWidth || '',
        height: this.fullscreen ? '100%' : '',
        maxHeight: this.modalHeight ,
        zIndex: (this.modalZindex + 2)
      }
    }
  },
  methods: {
    close() {
      this.$emit('closeModal');
    },
    signalClosing() {
      if(this.confirmOnClose) {
        this.closing = true;
      } else {
        this.close();
      }
    },
    closeModalClick() {
      if(this.confirmOnClose) {
        this.closing = !this.closing;
      } else {
        this.close();
      }
    }
  },
  created() {
    this.$store.dispatch('modal/inc');
    this.modalCounter = this.$store.getters['modal/getPosition'];
    this.$anm22.eventBus.$on('wg-modal-close', this.close);
    document.body.classList.add('bg-scrolling-element-when-modal-active');
  },
  components: {
    Portal
  },
  destroyed() {
    this.$store.dispatch('modal/dec');
    this.$anm22.eventBus.$off('wg-modal-close', this.close);
    document.body.classList.remove('bg-scrolling-element-when-modal-active');
  }
};
</script>

<style lang="scss" scoped>
  .modal-backdrop {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    // z-index: 10000;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    // -webkit-transform: translate3d(0,0,0);
  }

  .modal-outside-area {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    // z-index: 10001;
  }

  .modal-close {
    position: absolute;
    background: #FFFFFF;
    box-shadow: 0px 0px 20px 1px #888888;
    overflow-x: auto;
    display: flex;
    flex-direction: column;
    margin-top: env(safe-area-inset-top);
    margin-bottom: env(safe-area-inset-bottom);
    transform: translate3d(0,0,0);
    border-radius: 6px;

    input {
      padding: 9px 18px;
    }
  }

  .modal {
    background: #FFFFFF;
    box-shadow: 2px 2px 20px 1px;
    overflow-x: auto;
    display: flex;
    flex-direction: column;
    margin-top: env(safe-area-inset-top);
    margin-bottom: env(safe-area-inset-bottom);
    // z-index: 10002;
    transform: translate3d(0,0,0);
    border-radius: 6px;
  }

  .modal-header {
    flex-wrap: nowrap;
    justify-content: space-between;
    &.with-header {
      padding: 12px;
      min-height: 44px;
      border-bottom: 1px solid #eeeeee;
      align-items: center;
      white-space: nowrap;
    }
  }

  .modal-footer {
    border-top: 1px solid #eeeeee;
    justify-content: flex-end;
  }

  .modal-body {
    position: relative;
    padding: 20px 10px;
    &.no-header {
      padding: 20px 40px;
    }
    &.no-scroll-x {
      overflow-x: hidden;
    }
    &.no-scroll-y {
      overflow-y: hidden;
    }
  }

  .btn-close {
    margin-left:auto;
    padding: 3px;
    cursor: pointer;
    &.no-header {
      position: absolute;
      top:10px;
      right: 10px;
      margin: auto;
    }
  }
</style>

<style lang="scss">
  .bg-scrolling-element-when-modal-active {
    /* when modal active */
    touch-action: none;
    -webkit-overflow-scrolling: none;
    overflow: hidden;
    /* Other browsers */
    overscroll-behavior: none;
  }
</style>